<template>
  <div class="shop-form__block">
    <div class="shop-form__table _designs">
      <span
        class="shop-form__design"
        v-for="designType in sortedDesignByCurrentType"
        :key="designType.id"
        @click="setDesingType(designType.id)"
        :class="{ active: currentDesingType === designType.id }"

        :style="`background: url(${designType.image}) no-repeat center/ 110%;`"
      ></span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { TypeDesignObj } from "@/types/typesOfApi";
import { TypeLoyalityKinds } from "@/types";
const store = useStore();

const currentLoyalityKind = computed<TypeLoyalityKinds>(() => store.state.currentLoyalityKind);

const currentDesingType = computed<number>(
  () => store.state.loyalityShopData.designType
);

const allDesignTypes = computed<TypeDesignObj[]>(() => store.state.allDesignTypes);

const sortedDesignByCurrentType = computed(() => {
  if (currentLoyalityKind.value === 'abonement') {
    return allDesignTypes.value.filter(i => i.loyalty_type === 'abon')
  } else {
    return allDesignTypes.value.filter(i => i.loyalty_type === 'cert')
  }
})

function setDesingType(typeId: number): void {
  store.state.loyalityShopData.designType = typeId;
}
</script>

<style></style>
